export const en = {
  // Note: Search for 'pressTabToComplete' to find evaluation section
  auth: {
    login: "Sign In",
    signUp: "Sign Up",
    logout: "Sign Out",
    email: "Email",
    password: "Password",
    username: "Username",
    loginSubtitle: "Welcome back, coffee lover",
    signupSubtitle: "Join the coffee community",
    loginDescription: "Enter your credentials to access your account",
    signupDescription: "Create your account to start sharing brews",
    createAccount: "Create Account",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    alreadyMember: "Already a member?",
    signIn: "Sign in.",
    signingIn: "Signing in...",
    creatingAccount: "Creating account...",
    loginError: "Login failed",
    signupError: "Sign up failed",
    signupSuccess: "Account created!",
    checkEmail: "Check your email to confirm your account.",
    welcomeBack: "Welcome back!",
    usernameError: "Invalid username",
    usernameTooShort: "Username must be at least 3 characters.",
    usernameInvalid: "Username can only contain letters, numbers, and underscores.",
    usernameHint: "Letters, numbers, and underscores only",
    passwordHint: "At least 6 characters",
    welcomeTitle: "Hey, welcome back",
    welcomeSubtitle: "Good to see you again!",
    forgotPassword: "Forgot password?",
    orSignUp: "Or sign up",
    emailPlaceholder: "your.email@address.com",
    passwordPlaceholder: "Enter your password",
    signupWelcomeTitle: "Create your account",
    signupWelcomeSubtitle: "Join the coffee community",
    orSignIn: "Or sign in",
    // Roaster-specific auth strings
    roasterLoginSubtitle: "Sign in to your roaster dashboard",
    roasterEmailPlaceholder: "you@roastery.com",
    roasterNamePlaceholder: "Awesome Coffee Roasters",
    roasterSignupTitle: "Start collecting feedback",
    roasterSignupSubtitle: "Create your free roaster account",
    roasterNameTooShort: "Roastery name must be at least 2 characters",
    passwordResetComingSoon: "Password reset coming soon",
    termsAgreement: "By signing up, you agree to our Terms of Service and Privacy Policy.",
    // Branding panel
    brandingTitle: "Know Your Customers",
    brandingDescription: "Collect feedback, analyze trends, and make better coffee with AI-powered insights from your customers.",
    statsFeedback: "Feedback collected",
    statsRoasters: "Roasters",
  },
  common: {
    grinder: "Grinder",
    electric: "Electric",
    manual: "Manual",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    somethingWentWrong: "Something went wrong",
    errorOccurred: "An error occurred",
    errorLoadingData: "We couldn't load the data. Please try again.",
    retry: "Retry",
    tryAgain: "Try again",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    load: "Load",
    offset: "Offset",
    steps: "steps",
    clicks: "clicks",
    rotations: "rotations",
    position: "Position",
    beans: "Beans",
    processing: "Processing...",
    uploadSuccess: "Image uploaded!",
    uploadError: "Failed to upload image",
    imageRemoved: "Image removed",
    deleteError: "Failed to delete image",
    notFound: "Not Found",
    saving: "Saving...",
    clearAll: "Clear all",
  },
  storage: {
    bucketNotFound: "Storage not configured. Please contact support.",
    permissionDenied: "Permission denied. Please sign in and try again.",
    fileTooLarge: "File is too large. Please choose a smaller file.",
    invalidFileType: "Invalid file type. Please use JPEG, PNG, WebP, or GIF.",
    networkError: "Network error. Please check your connection and try again.",
  },
  header: {
    title: "CoffeeLog",
    subtitle: "Professional Calibration",
    lightTheme: "Light theme",
    darkTheme: "Dark theme",
  },
  nav: {
    contact: "Contact",
    joinForFree: "Join For Free",
  },
  slider: {
    realSteps: "Real Steps",
    fineToCoarse: "Fine ← → Coarse",
    min: "Min",
    max: "Max",
    zero: "Zero",
    settingsLabel: "Grind Settings",
  },
  brewMethods: {
    title: "Brew Methods",
    subtitle: "Select to auto-adjust",
    selected: "Selected",
    steps: "steps",
  },
  calibration: {
    currentSetting: "Current Setting",
    instructions: "Instructions",
    followSteps: "Follow the steps below",
    step1Title: "Set to Zero",
    step1Desc: "Align dial with",
    step2Title: "Turn Counter-Clockwise",
    rotation: "rotation",
    rotations: "rotations",
    step3Title: "Final Position",
    markAt: "Mark at",
    total: "Total",
    turningClockwise: "turning clockwise",
  },
  calibrate: {
    guestHeading: "Master your grind settings",
    guestDescription: "Dial in the perfect grind for any brew method. Sign up to save your calibrations and access them anytime.",
  },
  history: {
    title: "History",
    empty: "No saved calibrations",
    emptyDesc: "Save your favorite calibrations for quick access later. Your settings are stored locally.",
    savedCalibration: "saved calibration",
    savedCalibrations: "saved calibrations",
    favorites: "Favorites",
    recent: "Recent",
    hideNotes: "Hide notes",
    showNotes: "Show notes",
    notes: "Notes",
    offset: "Offset",
    steps: "Steps",
    rotations: "Rotations",
    addNotesPlaceholder: "Add notes...",
  },
  saveDialog: {
    title: "Save Calibration",
    nameLabel: "Calibration name",
    namePlaceholder: "E.g.: V60 medium roast",
    notesLabel: "Notes",
    notesPlaceholder: "Add details about the coffee, extraction result...",
    optional: "(optional)",
    required: "*",
    saveButton: "Save Calibration",
  },
  deleteDialog: {
    title: "Delete calibration?",
    description: "This action cannot be undone. The calibration \"{name}\" will be permanently removed.",
    confirm: "Delete",
  },
  actions: {
    load: "Load",
    favorite: "Favorite",
    unfavorite: "Unfavorite",
    edit: "Edit",
    delete: "Delete",
  },
  toasts: {
    grinderSelected: "{grinder}",
    settingsReset: "Grinder selected. Settings reset.",
    methodSelected: "{method} selected",
    calibrationSet: "Calibration set to {steps} real steps ({grindLevel})",
    calibrationSaved: "Calibration saved!",
    addedToHistory: "\"{name}\" was added to history.",
    calibrationLoaded: "Calibration loaded",
    appliedToDial: "\"{name}\" applied to dial.",
    calibrationDeleted: "Calibration deleted",
    removedFromHistory: "Calibration removed from history.",
  },
  footer: {
    tagline: "CoffeeLog · Professional calibration for coffee grinders",
    stepsNote: "100 steps = 1 full rotation",
  },
  grindLevels: {
    ultraFine: "Ultra Fine",
    fine: "Fine",
    mediumFine: "Medium-Fine",
    medium: "Medium",
    mediumCoarse: "Medium-Coarse",
    coarse: "Coarse",
    extraCoarse: "Extra Coarse",
  },
  grinderInfo: {
    title: "Your Grinder",
    imagePlaceholder: "Grinder Image",
    maxSteps: "Max Steps",
    stepsPerRotation: "Steps/Rotation",
    unit: "Unit",
    showInstructions: "Show instructions",
    hideInstructions: "Hide instructions",
    specifications: "Specifications",
  },
  offsetTooltip: "Offset is the difference between the marked zero and the real zero. Default: {default}.",
  social: {
    home: "Home",
    feed: "Feed",
    feedDesc: "See what coffee lovers you follow are brewing",
    discover: "Discover",
    myBrews: "My Brews",
    saved: "Saved",
    collection: "Collection",
    collectionDesc: "Your brews and saved favorites in one place.",
    profile: "Profile",
    create: "Create",
    navigation: "Navigation",
    tools: "Tools",
    calibrator: "Calibrator",
    searchPlaceholder: "Search brews, users...",
    shareBrew: "Share Brew",
    welcomeTitle: "Welcome to CoffeeLog",
    welcomeDesc: "Sign in to follow coffee enthusiasts and share your brews with the community.",
    noBrews: "No brews yet",
    noBrewsHomeDesc: "Follow other coffee lovers or share your first brew to get started!",
    noBrewsDiscoverDesc: "Be the first to share a brew with the community!",
    noBrewsSavedDesc: "Save brews you want to try later.",
    loadingBrews: "Loading brews...",
    exploreDiscover: "Explore Discover",
    copySettings: "Copy Settings",
    settingsCopied: "Settings copied!",
    settingsCopiedDesc: "Calibration settings from @{user}'s brew applied.",
    brewSaved: "Brew saved!",
    brewUnsaved: "Brew removed from saved.",
    loginRequired: "Please sign in to do this.",
    discoverDesc: "Explore public brews from the community.",
    savedDesc: "Brews you've saved for later.",
    myBrewsDesc: "All your shared brews.",
    // Phase 3 additions
    follow: "Follow",
    unfollow: "Unfollow",
    followers: "Followers",
    following: "Following",
    followsYou: "Follows you",
    noFollowers: "No followers yet",
    noFollowing: "Not following anyone",
    nowFollowing: "Now following @{username}",
    unfollowed: "Unfollowed @{username}",
    brews: "Brews",
    userBrews: "Brews",
    profileOverview: "Overview",
    favoriteGrinder: "Favorite grinder",
    memberSince: "Member since",
    createBrew: "Share a Brew",
    createBrewDesc: "Share your coffee brew with the community",
    coffeeName: "Coffee Name",
    coffeeOrigin: "Origin",
    roaster: "Roaster",
    grinder: "Grinder",
    selectGrinder: "Select grinder",
    brewMethod: "Brew Method",
    selectMethod: "Select method",
    notes: "Notes",
    notesPlaceholder: "Tasting notes, extraction details...",
    makePublic: "Make public",
    publicDesc: "Anyone can see this brew",
    sharing: "Sharing...",
    fillRequired: "Please fill all required fields",
    brewCreated: "Brew shared!",
    brewCreateError: "Failed to share brew",
    // Image upload
    imageUpload: "Photo",
    imageUploadHint: "Add a photo of your brew (optional)",
    dragDropImage: "Drag & drop or click to upload",
    maxFileSize: "Max 5MB",
    allowedFormats: "JPEG, PNG, WebP, GIF",
    removeImage: "Remove image",
    uploadingImage: "Uploading...",
    moderatingImage: "Checking image...",
    // Moderation errors
    imageRejected: "Image rejected",
    imageExplicitContent: "Image contains inappropriate content",
    imageViolence: "Image contains violent content",
    imageOffensive: "Image contains offensive content",
    imageTooLarge: "Image is too large (max 5MB)",
    imageInvalidType: "Invalid file type. Use JPEG, PNG, WebP or GIF",
    // Edit/Delete
    editBrew: "Edit Brew",
    editBrewDesc: "Update your brew details",
    deleteBrew: "Delete Brew",
    deleteBrewConfirm: "Are you sure you want to delete this brew?",
    deleteBrewDesc: "This action cannot be undone. The brew will be permanently removed.",
    brewUpdated: "Brew updated!",
    brewUpdateError: "Failed to update brew",
    brewDeleted: "Brew deleted!",
    brewDeleteError: "Failed to delete brew",
    updating: "Updating...",
    deleting: "Deleting...",
    replaceImage: "Replace image",
    keepCurrentImage: "Keep current image",
    // Lightbox
    closeLightbox: "Close",
    // Infinite scroll
    loadingMore: "Loading more...",
    noMoreBrews: "No more brews to load",
    // Pull-to-refresh
    pullToRefresh: "Pull to refresh",
    releaseToRefresh: "Release to refresh",
    refreshing: "Refreshing...",
    // Comments
    comment: "Comment",
    comments: "Comments",
    noComments: "No comments yet",
    noCommentsDesc: "Be the first to share your thoughts!",
    addComment: "Add a comment...",
    postComment: "Post",
    posting: "Posting...",
    commentPosted: "Comment posted!",
    commentDeleted: "Comment deleted",
    commentError: "Failed to post comment",
    deleteComment: "Delete comment",
    deleteCommentConfirm: "Delete this comment?",
    characterLimit: "{count}/{max}",
    // Moderation
    commentBlocked: "Comment blocked",
    commentOffensive: "Your comment contains offensive language",
    commentViolence: "Your comment contains violent content",
    commentHateSpeech: "Your comment contains hate speech",
    commentInappropriate: "Your comment contains inappropriate content",
    // Share
    share: "Share",
    linkCopied: "Link copied!",
    linkCopiedDesc: "The brew link has been copied to your clipboard.",
    shareTitle: "Check out this brew on CoffeeLog",
    viewDetails: "View Details",
    copy: "Copy",
    // Brew Detail
    brewInfo: "Brew Info",
    save: "Save",
    like: "Like",
    by: "by",
    noPhoto: "No photo",
    methodEquipment: "Method & Equipment",
    showLess: "Show less",
    showMore: "Show more",
    copyLinkError: "Failed to copy link",
    savedBy: "Saved by",
    person: "person",
    people: "people",
    recommended: "Recommended",
    basedOn: "Based on",
    rating: "rating",
    ratings: "ratings",
    // Hero Banner
    welcomeBack: "Welcome back!",
    welcomeBackDesc: "Ready to discover new brews or share your latest creation?",
    yourFeed: "Your Feed",
    latestBrews: "Latest Brews",
    explore: "Explore",
    expandBanner: "Show welcome banner",
    collapseBanner: "Hide banner",
    moreOptions: "More options",
    // Dashboard
    goodMorning: "Good morning",
    goodAfternoon: "Good afternoon",
    goodEvening: "Good evening",
    noBrewsToday: "You haven't brewed anything today. Time for coffee?",
    allTimeStats: "All time statistics",
    seeMore: "See more",
    whatBrewing: "What are you brewing?",
    methods: "Methods",
    likes: "Likes",
    inviteFriends: "Invite friends",
    feedback: "Feedback",
    upgrade: "Upgrade",
    // Collection UI
    totalBrews: "brews",
    totalLikes: "likes",
    totalComments: "comments",
    totalSaved: "saved",
    searchBrews: "Search brews...",
    filterByMethod: "Brew method",
    sortBy: "Sort",
    sortRecent: "Most recent",
    sortLikes: "Most liked",
    sortAlphabetical: "A-Z",
    viewGrid: "Grid view",
    viewList: "List view",
    allMethods: "All methods",
  },
  settings: {
    title: "Settings",
    description: "Manage your account and profile settings",
    profileSettings: "Profile",
    profileDesc: "Update your profile information",
    avatarUrl: "Avatar URL",
    avatarHint: "JPG, PNG, WebP or GIF. Max 3MB.",
    usernameNote: "Username cannot be changed",
    displayName: "Display Name",
    displayNamePlaceholder: "Your name",
    bio: "Bio",
    bioPlaceholder: "Tell us about yourself...",
    favoriteGrinder: "Favorite Grinder",
    selectGrinder: "Select your grinder",
    noGrinder: "None selected",
    saving: "Saving...",
    saveChanges: "Save Changes",
    updateSuccess: "Profile updated!",
    updateError: "Failed to update profile",
    changeAvatar: "Change Photo",
    removeAvatar: "Remove",
    uploading: "Uploading...",
    avatarUpdated: "Profile picture updated!",
    avatarRemoved: "Profile picture removed",
    avatarTooLarge: "Image must be smaller than 3MB",
    avatarInvalidType: "Only JPG, PNG, WebP, and GIF are allowed",
    avatarUploadError: "Failed to upload image",
    avatarRemoveError: "Failed to remove image",
    cropImage: "Crop Image",
    applyCrop: "Apply",
    cropError: "Failed to crop image",
    preferences: "Preferences",
    language: "Language",
    // Account section
    account: "Account",
    accountDesc: "Manage your email, password, and account",
    email: "Email",
    changeEmail: "Change",
    emailUpdated: "Email updated! Check your inbox to confirm.",
    emailUpdateError: "Failed to update email",
    password: "Password",
    changePassword: "Change",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    passwordUpdated: "Password updated!",
    passwordUpdateError: "Failed to update password",
    passwordMismatch: "Passwords do not match",
    passwordTooShort: "Password must be at least 6 characters",
    deleteAccount: "Delete Account",
    deleteAccountDesc: "Permanently delete your account and all data",
    deleteAccountConfirm: "Are you sure you want to delete your account? This action cannot be undone.",
    accountDeleted: "Account deleted",
    deleteAccountError: "Failed to delete account",
  },
  imageCropper: {
    title: "Crop Image",
    zoom: "Zoom",
    apply: "Apply",
    recrop: "Re-crop image",
  },
  notifications: {
    title: "Notifications",
    empty: "No notifications yet",
    emptyDesc: "You'll see activity on your brews here",
    markAllRead: "Mark all as read",
    liked: "@{user} liked your brew",
    commented: "@{user} commented on your brew",
    saved: "@{user} saved your brew",
    copiedSettings: "@{user} copied your brew settings",
    followed: "@{user} started following you",
    viewAll: "View all notifications",
  },
  evaluation: {
    title: "Tasting Evaluation",
    subtitle: "SCA Coffee Value Assessment",
    addEvaluation: "Add Tasting Notes",
    editEvaluation: "Edit Evaluation",
    removeEvaluation: "Remove Evaluation",
    fragrance: "Fragrance",
    aroma: "Aroma",
    flavor: "Flavor",
    aftertaste: "Aftertaste",
    acidity: "Acidity",
    sweetness: "Sweetness",
    mouthfeel: "Mouthfeel",
    overall: "Overall",
    fragranceDesc: "Dry coffee grounds smell",
    aromaDesc: "Wet coffee aroma",
    aromaNotesPlaceholder: "Describe the aromas you detect...",
    flavorDesc: "Taste and aroma combined",
    aftertasteDesc: "Lingering flavors after swallowing",
    acidityDesc: "Brightness and vibrancy",
    sweetnessDesc: "Natural sweetness",
    mouthfeelDesc: "Body and texture",
    overallDesc: "Your personal impression",
    nonUniformCups: "Non-uniform cups",
    defectiveCups: "Defective cups",
    selectCups: "Select any cups that differ",
    defects: "Defects",
    defectMoldy: "Moldy",
    defectPhenolic: "Phenolic",
    defectPotato: "Potato",
    score: "Score",
    totalScore: "Total Score",
    averageScore: "Average",
    outOf: "out of 9",
    save: "Save Evaluation",
    saving: "Saving...",
    saved: "Evaluation saved!",
    saveError: "Failed to save evaluation",
    removed: "Evaluation removed",
    noEvaluation: "No tasting evaluation yet",
    noEvaluationDesc: "Add your sensory notes to help others understand this coffee.",
    pressTabToComplete: "Press Tab to complete",
  },
  illustrations: {
    loginTagline: "Craft your perfect cup",
    signupTagline: "Join the brewing community",
    calibratorTagline: "Precision in every grind",
  },
  emptyStates: {
    noBrews: {
      title: "No brews yet",
      description: "Start documenting your coffee journey by creating your first brew.",
      cta: "Create your first brew",
    },
    noSaved: {
      title: "Nothing saved",
      description: "Discover amazing brews from the community and save your favorites.",
      cta: "Explore brews",
    },
    noResults: {
      title: "No results found",
      description: "Try adjusting your search or filters.",
    },
    notFound: {
      title: "Page not found",
      description: "Looks like this page wandered off to find better coffee.",
      cta: "Return home",
    },
  },
  // Dashboard / Roaster translations
  dashboard: {
    // Layout
    overview: "Overview",
    products: "Products",
    profiles: "Roast Profiles",
    integrations: "Integrations",
    settings: "Settings",
    signOut: "Sign out",
    // Dashboard page
    welcomeBack: "Welcome back, {name}",
    hereWhatsHappening: "Here's what's happening with your feedback",
    totalFeedback: "Total Feedback",
    averageRating: "Average Rating",
    thisWeek: "This Week",
    active: "Active",
    recentFeedback: "Recent Feedback",
    productWithLot: "{productName} ({lotNumber})",
    viewAll: "View all",
    noFeedbackYet: "No feedback yet",
    addProductToStart: "Add a product and share the QR code to start collecting feedback",
    yourProducts: "Your Products",
    manage: "Manage",
    noDetails: "No details",
    noProductsYet: "No products yet",
    addYourFirstProduct: "Add Your First Product",
    // Products page
    manageQrCodes: "Manage your coffee products and QR codes",
    addProduct: "Add Product",
    viewQrCode: "View QR Code",
    viewDetails: "View Details",
    delete: "Delete",
    qrCode: "QR Code",
    viewFeedback: "View Feedback",
    addFirstProductDesc: "Add your first coffee product to start collecting feedback from customers.",
    productCard: {
      feedback: "reviews",
    },
    // Add product dialog
    addNewProduct: "Add New Product",
    createProductDesc: "Create a coffee product to start collecting customer feedback.",
    productImage: "Product Image",
    productImageHint: "Add a photo of your coffee (optional)",
    coffeeName: "Coffee Name",
    origin: "Origin",
    process: "Process",
    roastLevel: "Roast Level",
    selectRoastLevel: "Select roast level",
    description: "Description",
    tastingNotesPlaceholder: "Tasting notes, farm story, etc.",
    cancel: "Cancel",
    creating: "Creating...",
    createProduct: "Create Product",
    productCreated: "Product created!",
    failedToCreateProduct: "Failed to create product",
    // Edit product dialog
    editProduct: "Edit Product",
    editProductDesc: "Update your coffee product details.",
    saving: "Saving...",
    saveProduct: "Save Changes",
    productUpdated: "Product updated!",
    failedToUpdateProduct: "Failed to update product",
    // QR dialog
    shareQrCode: "Share this QR code with your customers",
    // Delete dialog
    deleteProduct: "Delete Product?",
    deleteProductDesc: "This will permanently delete \"{name}\" and all associated feedback. This action cannot be undone.",
    deleting: "Deleting...",
    productDeleted: "Product deleted",
    failedToDeleteProduct: "Failed to delete product",
    // Product detail
    backToProducts: "Back to Products",
    totalReviews: "Total Reviews",
    wouldBuyAgain: "Would Buy Again",
    ratingDistribution: "Rating Distribution",
    allFeedback: "All Feedback",
    noFeedbackProductYet: "No feedback yet",
    shareQrToStart: "Share the QR code to start collecting reviews",
    getQrCode: "Get QR Code",
    productNotFound: "Product not found",
    positiveSentiment: "positive sentiment",
    negativeSentiment: "negative sentiment",
    neutralSentiment: "neutral sentiment",
    // Sentiment score
    sentiment: {
      positive: "Positive",
      neutral: "Neutral",
      negative: "Negative",
      score: "Sentiment Score",
      aiAnalysis: "AI Analysis",
    },
    // AI Insights Card
    aiInsights: {
      title: "AI Insights",
      subtitle: "Real-time analysis of your feedback",
      avgSentiment: "Average Sentiment Score",
      topTopics: "Top AI-Extracted Topics",
      noTopics: "No topics extracted yet",
      processedFeedback: "{count} of {total} feedback analyzed",
    },
    aiDisclaimer: "AI insights are for reference only. Always verify before making decisions.",
    aiDisclaimerLink: "Learn more",
    // AI Upgrade prompts (for free tier users)
    aiUpgrade: {
      title: "Unlock AI Insights",
      description: "Upgrade to Starter or Pro to get AI-powered sentiment analysis, topic extraction, and smart alerts.",
      summaryTitle: "Unlock Weekly Summaries",
      summaryDescription: "Upgrade to get AI-generated weekly summaries with actionable suggestions for your products.",
      button: "Upgrade Now",
    },
    // Channel Insights Card
    channelInsights: {
      title: "Channel Performance",
      subtitle: "Performance by purchase channel",
      topPerformer: "Top",
      reviews: "reviews",
      avgRating: "Avg. Rating",
      repeatIntent: "Repeat Intent",
      positiveSentiment: "Positive",
    },
    // Health Score
    healthScore: {
      title: "Health Score",
      subtitle: "Overall product performance",
      excellent: "Excellent",
      good: "Good",
      fair: "Fair",
      poor: "Poor",
    },
    // Repeat Analysis
    repeatAnalysis: {
      title: "Repeat Purchase Analysis",
      subtitle: "Would buy again insights",
      overallRepeat: "Overall Repeat Intent",
      byChannel: "By Channel",
      highRatingLowRepeat: "High rating, low repeat",
      lowRatingHighRepeat: "Low rating, high repeat",
    },
    // Taste Insights
    tasteInsights: {
      title: "Taste Profile Insights",
      subtitle: "Flavor preferences and recommendations",
      flavorProfiles: "Flavor Profiles",
      topTags: "Top Performing Tags",
      recommendations: "Recommendations",
      needMoreData: "Collect more feedback to unlock taste insights",
      clusterBrightFruity: "Bright & Fruity",
      clusterSweetSmooth: "Sweet & Smooth",
      clusterRichBold: "Rich & Bold",
      clusterFloralDelicate: "Floral & Delicate",
      clusterComplexSpicy: "Complex & Spicy",
    },
    wouldBuyAgainYes: "Would buy again",
    wouldBuyAgainNo: "Would not buy again",
    // Roast levels
    light: "Light",
    mediumLight: "Medium-Light",
    medium: "Medium",
    mediumDark: "Medium-Dark",
    dark: "Dark",
    // Processes
    washed: "Washed",
    natural: "Natural",
    honey: "Honey",
    naturalFermented: "Natural Fermented",
    lateHarvestNatural: "Late Harvest Natural",
    anaerobicFermentation: "Anaerobic Fermentation",
    anaerobic: "Anaerobic",
    other: "Other",
    select: "Select",
    // Lots
    manageLots: "Manage Lots",
    manageProductsAndLots: "Manage your coffee products and roasting lots",
    // Charts
    charts: {
      sentimentDistribution: "Sentiment Distribution",
      ratingTrend: "Rating Trend",
      feedbackVolume: "Feedback Volume",
      topTasteTags: "Top Taste Tags",
      purchaseChannels: "Purchase Channels",
      aiExtractedTopics: "AI-Extracted Topics",
      aiExtractedTopicsHint: "Themes identified by AI from customer comments",
      noData: "No data available yet",
      noAiTopics: "No AI-extracted topics yet",
      aiTopicsHint: "Topics will appear as more feedback is analyzed",
      positive: "Positive",
      neutral: "Neutral",
      negative: "Negative",
      avgRating: "Avg. Rating",
      feedbackCount: "Feedback",
      mentions: "Mentions",
      purchases: "Purchases",
      last30Days: "Last 30 days",
      flavorNotes: "Flavor Notes",
      flavorNotesHint: "Most mentioned flavor notes",
      sensoryProfile: "Sensory Profile",
      sensoryProfileHint: "Distribution of sensory descriptors",
      tasteRatingCorrelation: "Taste-Rating Correlation",
      tasteRatingCorrelationHint: "Average rating by taste tag",
      wouldBuyAgainTrend: "Repeat Intent Trend",
      wouldBuyAgainTrendHint: "Would buy again percentage over time",
      percent: "%",
      channels: {
        roasting: "Roasting",
        online: "Online",
        cafe: "Café",
        grocery: "Grocery",
        subscription: "Subscription",
        gift: "Gift",
        other: "Other",
      },
    },
  },
  roasterOnboarding: {
    roasterProfile: "Roaster Profile",
    firstProduct: "First Product",
    setupRoasterProfile: "Set up your roaster profile",
    tellUsAboutRoastery: "Tell us about your roastery",
    roasteryName: "Roastery Name",
    yourUrl: "Your URL",
    websiteOptional: "Website (optional)",
    continue: "Continue",
    creatingRoaster: "Creating...",
    roasterCreated: "Roaster profile created!",
    slugTaken: "Slug already taken",
    chooseAnotherName: "Please choose a different name or modify the URL.",
    failedToCreateRoaster: "Failed to create roaster",
    addFirstProduct: "Add your first product",
    createCoffeeToStart: "Create a coffee to start collecting feedback",
    skipForNow: "Skip for now",
    firstProductReady: "Your first product is ready!",
  },
  roasterSettings: {
    title: "Settings",
    manageProfileAccount: "Manage your roaster profile and account",
    roasterProfile: "Roaster Profile",
    publicRoasterInfo: "Your public roaster information",
    logo: "Roastery Logo",
    logoHint: "Upload your roastery logo (square, max 3MB)",
    roasteryName: "Roastery Name",
    yourUrl: "Your URL",
    website: "Website",
    saving: "Saving...",
    saveChanges: "Save Changes",
    settingsSaved: "Settings saved",
    urlAlreadyTaken: "URL already taken",
    failedToSave: "Failed to save changes",
    subscription: "Subscription",
    managePlanBilling: "Manage your plan and billing",
    free: "Free",
    starter: "Starter",
    pro: "Pro",
    freeDesc: "1 product, 50 feedback/month",
    starterDesc: "5 products, 500 feedback/month",
    proDesc: "Unlimited products & lots, 2000 feedback/month",
    unlimitedDesc: "Unlimited",
    upgrade: "Upgrade",
    manageSubscription: "Manage",
    account: "Account",
    manageAccountSettings: "Manage your account settings",
    email: "Email",
    fullName: "Full Name",
    fullNamePlaceholder: "Enter your full name",
    fullNameSaved: "Name updated",
    fullNameError: "Failed to update name",
    signOutTitle: "Sign Out",
    signOutDesc: "Sign out of your account",
    deleteAccount: "Delete Account",
    deleteAccountDesc: "Permanently delete your account and all data",
    deleteAccountConfirm: "Delete Account?",
    deleteAccountWarning: "This will permanently delete your roaster profile, all products, and all feedback. This action cannot be undone.",
    accountDeleted: "Account deleted",
    failedToDeleteAccount: "Failed to delete account",
    // New UX strings
    unsavedChanges: "Unsaved changes",
    unsavedChangesDesc: "You have unsaved changes. Are you sure you want to leave?",
    discardChanges: "Discard changes",
    keepEditing: "Keep editing",
    signOutConfirm: "Sign Out?",
    signOutConfirmDesc: "Are you sure you want to sign out of your account?",
    profileTab: "Profile",
    billingTab: "Billing",
    accountTab: "Account",
    urlPreview: "Your public profile will be at:",
    slugHint: "Only lowercase letters, numbers, and hyphens",
    nameRequired: "Name is required",
    slugRequired: "URL is required",
    slugInvalid: "Only lowercase letters, numbers, and hyphens allowed",
    changesSaved: "Your changes have been saved",
    keyboardShortcut: "Press {shortcut} to save",
    currentPlan: "Current plan",
    planFeatures: "Plan features",
    productsLimit: "{count} products",
    feedbackLimit: "{count} feedback/month",
    unlimitedProducts: "Unlimited products",
    unlimitedFeedback: "Unlimited feedback",
    viewPlans: "View all plans",
    dangerZone: "Danger Zone",
    dangerZoneDesc: "Irreversible and destructive actions",
    lastSaved: "Last saved {time}",
    neverSaved: "Not saved yet",
    // Language settings
    aiLanguage: "Language",
    aiLanguageHint: "Language for the app interface and AI-generated content",
    languageEnglish: "English",
    languagePortuguese: "Portuguese (Brazil)",
    // Feedback settings
    feedbackSettings: "Feedback Settings",
    feedbackSettingsDesc: "Customize how you handle customer feedback",
    lowRatingMessage: "Low Rating Message",
    lowRatingMessageHint: "Custom message shown to customers who give 1-2 stars",
    lowRatingMessagePlaceholder: "We're sorry to hear about your experience. We truly value your feedback and would love the opportunity to make things right.",
    collectContactOnLowRating: "Collect contact info for low ratings",
    collectContactOnLowRatingDesc: "Ask dissatisfied customers if they'd like to be contacted",
    rateLimitingEnabled: "Rate limiting",
    rateLimitingEnabledDesc: "Limits how many times the same person can submit feedback to prevent spam and abuse",
    disableRateLimitingTitle: "Disable rate limiting?",
    disableRateLimitingWarning: "Without rate limiting, your feedback form will be more vulnerable to spam submissions, automated bots, and potential abuse. This may result in unreliable data and increased costs. Only disable this if you have a specific reason, such as organized cupping sessions where many evaluations happen in a short time.",
    disableRateLimitingConfirm: "Disable rate limiting",
    // Address
    address: "Roastery Address",
    addressHint: "Search for your roastery address",
    addressPlaceholder: "Start typing your address...",
    addressResolveFailed: "Failed to resolve address. Please try again.",
    clearAddress: "Clear address",
    city: "City",
    state: "State",
    zip: "ZIP Code",
    country: "Country",
    // Social links
    socialLinks: "Social Links",
    socialLinksDesc: "Connect your social profiles",
    instagramUrl: "Instagram",
    instagramUrlPlaceholder: "https://instagram.com/your-roastery",
    googleBusinessUrl: "Google Business Profile",
    googleBusinessUrlPlaceholder: "https://g.page/your-roastery",
    // Privacy settings
    privacySettings: "Public Profile Privacy",
    privacySettingsDesc: "Control what contact information is visible on your public page",
    roasterEmail: "Contact Email",
    roasterEmailHint: "Public contact email (separate from your account email)",
    roasterPhone: "Contact Phone",
    roasterPhoneHint: "Public contact phone number",
    shareEmailPublicly: "Show email on public profile",
    shareEmailPubliclyDesc: "Display your contact email on your public roaster page",
    sharePhonePublicly: "Show phone on public profile",
    sharePhonePubliclyDesc: "Display your contact phone on your public roaster page",
  },
  feedbackForm: {
    productNotFound: "Product Not Found",
    invalidQrCode: "This QR code is invalid or the product is no longer available.",
    thankYou: "Thank You!",
    yourFeedbackHelps: "Your feedback helps {name} make better coffee.",
    submitAnother: "Submit Another Review",
    howWouldYouRate: "How would you rate this coffee?",
    whatFlavors: "What flavors did you taste? (optional)",
    additionalThoughts: "Any additional thoughts? (optional)",
    tellUsPlaceholder: "Tell us what you liked or what could be better...",
    whereBuy: "Where did you buy this? (optional)",
    selectPurchaseLocation: "Select purchase location",
    wouldBuyAgain: "Would you buy this again?",
    yes: "Yes",
    no: "No",
    pleaseSelectRating: "Please select a rating",
    failedToSubmit: "Failed to submit feedback. Please try again.",
    submitting: "Submitting...",
    submitFeedback: "Submit Feedback",
    poweredBy: "Powered by RoastPulse",
    // Purchase channels
    roasting: "Roasting",
    online: "Online",
    cafeShop: "Cafe/Coffee Shop",
    groceryStore: "Grocery Store",
    subscription: "Subscription",
    gift: "Gift",
    other: "Other",
    // Limit reached
    feedbackLimitReached: "Feedback Limit Reached",
    feedbackLimitReachedDesc: "{name} has reached their monthly feedback limit. Please try again next month.",
    tryAgainNextMonth: "The feedback form will be available again at the start of next month.",
    // Security errors
    rateLimitExceeded: "You've submitted too many reviews. Please try again later.",
    captchaFailed: "Security verification failed. Please refresh the page and try again.",
    // Taste tags
    fruity: "Fruity",
    floral: "Floral",
    sweet: "Sweet",
    nutty: "Nutty",
    chocolatey: "Chocolatey",
    spicy: "Spicy",
    earthy: "Earthy",
    citrus: "Citrus",
    berry: "Berry",
    caramel: "Caramel",
    bright: "Bright",
    smooth: "Smooth",
    bold: "Bold",
    balanced: "Balanced",
    // New flavor notes
    greenVegetative: "Green/Vegetative",
    sourFermented: "Sour/Fermented",
    roasted: "Roasted",
    stoneFruit: "Stone Fruit",
    tropical: "Tropical",
    driedFruit: "Dried Fruit",
    honey: "Honey",
    vanilla: "Vanilla",
    brownSugar: "Brown Sugar",
    molasses: "Molasses",
    toffee: "Toffee",
    cocoa: "Cocoa",
    cerealMalty: "Cereal/Malty",
    smoky: "Smoky",
    herbal: "Herbal",
    teaLike: "Tea-like",
    winey: "Winey",
    fermented: "Fermented",
    // New sensory descriptors
    crisp: "Crisp",
    juicy: "Juicy",
    silky: "Silky",
    creamy: "Creamy",
    round: "Round",
    delicate: "Delicate",
    clean: "Clean",
    longFinish: "Long finish",
    dryFinish: "Dry finish",
    // Section label
    whatSensations: "What sensations did you notice? (optional)",
    // Low rating apology section
    sorryToHear: "We're sorry to hear about your experience",
    sorryMessage: "We truly value your feedback and would love the opportunity to make things right.",
    wouldYouLikeContact: "Would you like us to reach out?",
    contactOptional: "Sharing your contact info is completely optional",
    yourName: "Your name",
    yourEmail: "Your email",
    yourPhone: "Your phone",
    namePlaceholder: "How should we call you?",
    emailPlaceholder: "your@email.com",
    phonePlaceholder: "+1 (555) 123-4567",
  },
  alerts: {
    showLess: "Show less",
    showMore: "Show more alerts",
    moreAlerts: "{count} more alert",
    moreAlertsPlural: "{count} more alerts",
    dismissAll: "Dismiss all",
    dismiss: "Dismiss",
    // Alert type labels
    rating_drop: "Rating Drop",
    negative_spike: "Negative Spike",
    low_volume: "Low Volume",
    high_repeat_intent: "High Repeat Intent",
    channel_mismatch: "Channel Mismatch",
    emerging_preference: "Emerging Preference",
  },
  aiSummary: {
    title: "AI Insights",
    comingSoon: "Coming soon...",
    weeklyInsights: "Weekly AI-generated insights",
    noFeedbackYet: "Once you have more feedback, AI will generate weekly summaries and actionable suggestions to help you improve.",
    weeklyAiSummary: "Weekly AI Summary",
    summaryFor: "Weekly summary for {productName} ({lotNumber})",
    basedOnReviews: "Based on {count} reviews",
    viewLotDetails: "View lot details",
    trendingTopics: "Trending topics:",
    suggestions: "Suggestions",
  },
  roastingInsights: {
    title: "Roasting Insights",
    subtitle: "AI analysis of your lot profiles",
    basedOnLots: "Based on {count} lots",
    consistencyScore: "Consistency score",
    suggestions: "Suggestions",
    emptyState: "Add lots with roasting variables (charge temp, bean temp, roast time, etc.) to get AI-powered insights on consistency, trends, and recommendations.",
    upgradeTitle: "Unlock Roasting Insights",
    upgradeDescription: "Upgrade to get AI analysis of your roasting profiles—consistency, trends, outliers, and actionable suggestions.",
  },
  lots: {
    // Page
    backToProducts: "Back to Products",
    backToLots: "Back to Lots",
    manageLots: "Manage roasting lots",
    addLot: "Add Lot",
    noLotsYet: "No lots yet",
    addFirstLotDesc: "Create your first roasting lot to start collecting feedback from customers.",
    addYourFirstLot: "Add Your First Lot",
    noRoastDate: "No roast date",
    // Lot card
    viewQrCode: "View QR Code",
    viewDetails: "View Details",
    viewFeedback: "View Feedback",
    qrCode: "QR Code",
    delete: "Delete",
    // Add lot dialog
    addNewLot: "Add New Lot",
    createLotDesc: "Create a roasting lot with the process variables for this batch.",
    lotNumber: "Lot Number",
    roastedAt: "Roasted At",
    selectDate: "Select a date",
    // Variables sections
    heatAndTimeVariables: "Heat & Time Variables",
    operationalVariables: "Operational Variables",
    rawMaterialVariables: "Raw Material Variables",
    roastingVariables: "Roasting Variables",
    // Roasting variable labels
    chargeTemperature: "Charge Temp",
    beanTemperature: "Bean Temp",
    environmentalTemperature: "Env. Temp",
    ambientHumidity: "Ambient Humidity",
    rateOfRise: "Rate of Rise",
    roastTime: "Roast Time",
    airflow: "Airflow",
    drumSpeed: "Drum Speed",
    batchSize: "Batch Size",
    beanMoisture: "Bean Moisture",
    beanDensity: "Bean Density",
    selectDensity: "Select density",
    roastLevel: "Roast Level",
    selectRoastLevel: "Select roast level",
    notes: "Notes",
    notesPlaceholder: "Additional notes about this roast...",
    // Variable tooltips
    chargeTemperatureTooltip: "The initial temperature of the roaster drum when the green coffee is dropped in. Higher charge temps speed up the roast.",
    beanTemperatureTooltip: "The temperature measured by a probe inside the bean mass. This is the most crucial measurement during roasting.",
    environmentalTemperatureTooltip: "The air temperature inside the drum, indicating how quickly the roast is progressing.",
    ambientHumidityTooltip: "The humidity percentage in the roasting environment. Higher humidity can affect heat transfer and roast development.",
    rateOfRiseTooltip: "The speed at which the bean temperature increases per minute. Controlling RoR (usually decreasing) is essential to avoid uneven roasts.",
    roastTimeTooltip: "The total duration from charge to cooling, influencing flavor development. Longer roasts tend to develop more body.",
    airflowTooltip: "Controls smoke and chaff exhaust, and regulates convection heat transfer. More airflow increases convection and helps remove smoky flavors.",
    drumSpeedTooltip: "Adjusts bean agitation. Too fast may scorch beans on the drum wall; too slow may result in insufficient agitation.",
    batchSizeTooltip: "The amount of coffee loaded into the roaster. Larger batches require more energy and longer roast times.",
    beanMoistureTooltip: "Coffees with higher moisture may require longer drying phases and more initial energy input.",
    beanDensityTooltip: "Denser beans or different processing methods (natural, washed, honey) react differently to heat application.",
    // Density options
    density: {
      low: "Low",
      medium: "Medium",
      high: "High",
    },
    // Actions
    creating: "Creating...",
    createLot: "Create Lot",
    createLotAndSaveProfile: "Create Lot & Save Profile",
    lotCreated: "Lot created!",
    failedToCreateLot: "Failed to create lot",
    // QR dialog
    shareQrCode: "Share this QR code with your customers",
    // Delete dialog
    deleteLot: "Delete Lot?",
    deleteLotDesc: "This will permanently delete \"{name}\" and all associated feedback. This action cannot be undone.",
    deleting: "Deleting...",
    lotDeleted: "Lot deleted",
    failedToDeleteLot: "Failed to delete lot",
    // Lot detail
    lotNotFound: "Lot not found",
    noFeedbackLotYet: "No feedback for this lot yet",
    shareQrToStart: "Share the QR code to start collecting reviews",
    getQrCode: "Get QR Code",
    productNotFound: "Product not found",
    // Import modes
    manualEntry: "Manual Entry",
    importFromFile: "Import from File",
    importPreviewNote: "Select a file to preview the roast data. You can review and edit before creating the lot.",
  },
  // Form validation
  validation: {
    lotNumberRequired: "Lot number is required",
    lotNumberTooLong: "Lot number must be 50 characters or less",
    roastedAtRequired: "Roast date is required",
    temperatureRange: "Temperature must be between 0 and 400°C",
    humidityRange: "Humidity must be between 0 and 100%",
    rorRange: "Rate of rise must be between 0 and 50°C/min",
    roastTimeMinutesRange: "Minutes must be between 0 and 60",
    roastTimeSecondsRange: "Seconds must be between 0 and 59",
    airflowRange: "Airflow must be between 0 and 100%",
    drumSpeedRange: "Drum speed must be between 0 and 200 RPM",
    batchSizeRange: "Batch size must be between 0 and 500 kg",
    moistureRange: "Moisture must be between 0 and 100%",
    notesTooLong: "Notes must be 1000 characters or less",
  },
  // Profiles feature
  profiles: {
    title: "Roast Profiles",
    subtitle: "Save and reuse your roasting configurations",
    noRoaster: "No roaster profile found",
    infoBanner: "Roast profiles let you save your favorite configurations. When creating a lot, select a profile to quickly populate the form with saved values.",
    // Selector
    loading: "Loading profiles...",
    selectProfile: "Select a profile",
    noProfiles: "No profiles saved",
    manualEntry: "Manual entry (blank form)",
    productProfiles: "Product profiles",
    globalProfiles: "Global profiles",
    loadFromProfile: "Load from profile",
    // Manager
    noProfilesTitle: "No saved profiles",
    noProfilesDescription: "Create roast profiles to save your favorite configurations and quickly reuse them when creating new lots.",
    loadError: "Failed to load profiles",
    default: "Default",
    // Save dialog
    saveAsProfile: "Save as Profile",
    saveDescription: "Save your current roasting configuration as a reusable profile.",
    name: "Profile Name",
    namePlaceholder: "e.g., Light Roast Default",
    description: "Description",
    descriptionPlaceholder: "Optional notes about this profile...",
    saveForProduct: "Product-specific profile",
    saveForProductDescription: "Only show this profile when creating lots for this product",
    setAsDefault: "Set as default",
    setAsDefaultDescription: "Pre-select this profile when creating new lots",
    nameRequired: "Profile name is required",
    save: "Save Profile",
    saveSuccess: "Profile saved!",
    saveFailed: "Failed to save profile",
    // Edit dialog
    editProfile: "Edit Profile",
    editDescription: "Update this roasting profile's settings.",
    roastingParameters: "Roasting Parameters",
    updateSuccess: "Profile updated!",
    updateFailed: "Failed to update profile",
    // Delete
    deleteTitle: "Delete Profile?",
    deleteDescription: "This will permanently delete \"{name}\". This action cannot be undone.",
    deleteSuccess: "Profile deleted",
    deleteFailed: "Failed to delete profile",
    // Set default
    setDefaultSuccess: "Profile set as default",
    setDefaultFailed: "Failed to set default profile",
  },
  // Market feature
  market: {
    title: "Coffee Market",
    subtitle: "CEPEA/ESALQ Brazilian Coffee Indicator",
    types: {
      arabica: "Arabica",
      robusta: "Robusta",
    },
    price: "Price",
    pricePerBag: "Price per 60kg bag",
    bag: "bag",
    daily: "daily",
    monthly: "monthly",
    lastUpdated: "Last updated",
    source: "Source",
    indicator: "Indicator",
    currentPrice: "Current price",
    priceAtRoast: "Price at roast date",
    coffeeType: "Coffee Type",
    lotReference: "Market Price Reference",
    actions: {
      sync: "Sync market prices",
      retry: "Retry",
    },
    error: {
      loadFailed: "Failed to load market prices",
    },
    chart: {
      noData: "No price data available",
      last30Days: "30-day trend",
    },
    costAnalysis: {
      title: "Market Price Analysis",
      noData: "No lots with market prices yet",
      noDataHint: "Create lots with market price tracking enabled",
      avgPrice: "Avg. Price",
      minPrice: "Min Price",
      maxPrice: "Max Price",
      lotsTracked: "Lots Tracked",
      recentLots: "Recent Lots",
    },
  },
  // Integrations feature
  integrations: {
    title: "Integrations",
    subtitle: "Connect your roasting software to auto-import profiles",
    connected: "Connected",
    syncError: "Sync Error",
    lastSynced: "Last synced",
    syncing: "Syncing...",
    syncNow: "Sync Now",
    disconnect: "Disconnect",
    noRoaster: "No roaster profile found",
    connectedSuccess: "Successfully connected to {provider}!",
    connectionError: "Connection failed: {error}",
    needHelp: "Need Help?",
    helpText: "Each integration has different setup requirements. Here's how to get started:",
    // Artisan
    artisan: {
      description: "Import roast profiles from Artisan software (.alog files)",
      instructions: "Export your roast profiles from Artisan and upload them here. The data will be parsed and you can create lots from imported profiles.",
      supportedFormats: "Supported formats",
      uploadNote: "Artisan files can be uploaded directly when creating a new lot. Go to Products → Select Product → Add Lot → Import from File.",
      helpText: "Export roasts as .alog files from File → Export → Artisan Log File",
      dragDrop: "Drag & drop Artisan .alog files here, or click to browse",
      dropHere: "Drop files here...",
      filesSelected: "{count} file(s) selected",
      importing: "Importing...",
      importAll: "Import {count} file(s)",
      allImported: "All {count} files imported successfully!",
      importSuccess: "{count} roast(s) imported successfully!",
    },
  },
  qrGenerator: {
    printQrCode: "Print this QR code on your coffee bags. Customers scan it to leave feedback.",
    copyLink: "Copy Link",
    copyImage: "Copy Image",
    copied: "Copied!",
    downloadPng: "Download PNG",
    scanToRate: "Scan to rate this coffee",
    qrCodeDownloaded: "QR code downloaded",
    linkCopied: "Link copied to clipboard",
    imageCopied: "Image copied to clipboard",
    failedToCopy: "Failed to copy link",
    failedToCopyImage: "Failed to copy image",
  },
  filters: {
    // Date range
    dateRange: "Date Range",
    last7Days: "Last 7 days",
    last30Days: "Last 30 days",
    last90Days: "Last 90 days",
    yearToDate: "Year to date",
    customRange: "Custom range",
    apply: "Apply",
    // Products
    products: "Products",
    allProducts: "All Products",
    oneProduct: "1 product",
    productsSelected: "{count} products",
    productsAndMore: "{name} +{count} more",
    searchProducts: "Search products...",
    noProductsFound: "No products found",
    // Lots
    lots: "Lots",
    allLots: "All lots",
    oneLot: "1 lot",
    lotsSelected: "{count} lots",
    lotsAndMore: "{name} +{count} more",
    searchLots: "Search lots...",
    noLotsFound: "No lots found",
    selectAll: "Select all",
    clearAll: "Clear all",
    // Sentiment
    sentiment: "Sentiment",
    filterBySentiment: "Filter by sentiment",
    sentimentsSelected: "{count} sentiments",
    // Rating
    rating: "Rating",
    filterByRating: "Filter by rating",
    ratingsSelected: "{count} ratings",
    stars: "stars",
    // Channel
    channel: "Channel",
    filterByChannel: "Filter by purchase channel",
    channelsSelected: "{count} channels",
    // Compare
    compare: "Compare",
    compareOff: "Compare: Off",
    comparePeriod: "Compare periods",
    compareProduct: "Compare products",
    comparing: "Comparing",
    comparingProducts: "Comparing products",
    vs: "vs",
    selectProductToCompare: "Select a product to compare",
    selectedProducts: "Selected products",
    compareWith: "Compare with",
    // General
    filters: "Filters",
    activeFilters: "{count} active filters",
    reset: "Reset",
    applyFilters: "Apply Filters",
    scope: "Scope",
    feedbackFilters: "Filter by feedback",
    noProductsYet: "No products yet",
    noLotsForProducts: "No lots for selected products",
    addLotsHint: "Add lots in Products",
    clearAllFilters: "Clear all",
    removeFilter: "Remove filter",
    // Comparison labels
    current: "Current",
    comparison: "Comparison",
    previous: "Previous",
    change: "Change",
    // Export
    export: "Export",
    exportCsv: "Export CSV",
    exportPdf: "Export PDF",
    share: "Share",
    shareDashboard: "Share Dashboard",
    linkCopied: "Link copied!",
    copyLink: "Copy Link",
  },
  followUp: {
    title: "Follow-Up Queue",
    subtitle: "Negative customer ratings to track and resolve",
    pending: "pending",
    needsAction: "Needs action",
    completed: "Completed",
    loadingItems: "Loading items...",
    new: "New",
    inProgress: "In Progress",
    resolved: "Resolved",
    dismissed: "Dismissed",
    allCaughtUp: "All caught up!",
    noNegativeFeedback: "No negative feedback requires follow-up",
    sendEmail: "Send Email",
    updateStatus: "Update",
    viewAll: "View all ({count})",
    updateStatusTitle: "Update Follow-Up Status",
    notes: "Notes",
    notesPlaceholder: "Add notes about your follow-up action...",
    markInProgress: "In Progress",
    markResolved: "Resolved",
    dismiss: "Dismiss",
    statusUpdated: "Status updated",
    statusUpdatedDesc: "Follow-up status has been updated",
    updateError: "Failed to update status",
  },
  home: {
    // Header
    signIn: "Sign in",
    getStarted: "Get Started",
    // Hero
    heroTitle: "Know what your customers think",
    heroSubtitle: "Collect feedback directly from coffee drinkers. Get AI-powered insights to improve your roasts and grow your business.",
    startFreeTrial: "Start Free Trial",
    seeDemo: "See Demo",
    freeNote: "Free for 1 product. No credit card required.",
    // How it works
    howItWorks: "How it works",
    step1Title: "Add QR to your bags",
    step1Desc: "Generate unique QR codes for each coffee product. Print them on your bags or labels.",
    step2Title: "Customers scan & rate",
    step2Desc: "A simple, mobile-friendly form. No app download. 30 seconds to complete.",
    step3Title: "Get actionable insights",
    step3Desc: "See ratings, trends, and AI-powered analysis of what customers love (and don't).",
    // Features
    aiPoweredInsights: "AI-Powered Insights",
    sentimentAnalysis: "Sentiment Analysis",
    sentimentAnalysisDesc: "Automatically categorize feedback as positive, neutral, or negative. Track sentiment trends over time.",
    topicExtraction: "Topic Extraction",
    topicExtractionDesc: "AI identifies what customers talk about: taste, freshness, packaging, value, and more.",
    weeklySummaries: "Weekly Summaries",
    weeklySummariesDesc: "Get a plain-English summary of your feedback. Know exactly what's working and what needs attention.",
    qualityAlerts: "Quality Alerts",
    qualityAlertsDesc: "Get notified when ratings drop. Catch quality issues before they become problems.",
    // Pricing
    simplePricing: "Plans",
    pricingSubtitle: "Start free with 1 product. Upgrade as you grow.",
    free: "Free",
    forever: "forever",
    freeFeature1: "1 product",
    freeFeature2: "50 feedback/month",
    freeFeature3: "Basic analytics",
    popular: "Popular",
    starter: "Starter",
    starterFeature1: "5 products",
    starterFeature2: "500 feedback/month",
    starterFeature3: "AI insights",
    starterAiFeatures: ["Sentiment analysis", "Topic extraction"],
    pro: "Pro",
    proFeature1: "Unlimited products & lots",
    proFeature2: "2000 feedback/month",
    proFeature3: "Full AI suite",
    proAiFeatures: ["Weekly AI summaries", "Practical suggestions", "Smart alerts"],
    proAiIncludesStarter: "Includes all Starter AI features",
    product: "product",
    products: "products",
    lots: "lots",
    unlimitedProducts: "Unlimited products",
    unlimitedFeedback: "Unlimited feedback",
    withYearlyBilling: "with yearly billing",
    allPlansInclude: "All plans include QR code generation and dashboard access. AI features available on Starter and Pro.",
    perMonth: "/month",
    // Footer
    copyright: "© {year} RoastPulse. All rights reserved.",
    footerTagline: "The feedback platform built for coffee roasters. Understand your customers, improve your products.",
    footerProduct: "Product",
    footerFeatures: "Features",
    footerPricing: "Pricing",
    footerCompany: "Company",
    footerAbout: "About",
    footerContact: "Contact",
    footerLegal: "Legal",
    footerPrivacy: "Privacy Policy",
    footerTerms: "Terms of Service",
    footerNewsletter: "Stay Updated",
    footerNewsletterDesc: "Get product updates and coffee industry insights.",
    footerEmailPlaceholder: "Enter your email",
    footerSubscribe: "Subscribe",
    // Benefits section
    benefits: "Key Benefits",
    benefitsSubtitle: "Everything you need to understand your customers",
    effortlessFeedback: "Effortless Feedback Collection",
    effortlessFeedbackDesc: "Generate QR codes for your packaging. Customers submit feedback in 60 seconds - no account needed.",
    understandCustomers: "Understand Your Customers",
    understandCustomersDesc: "See which flavor profiles resonate, track purchase channels, and know which products drive repeat purchases.",
    aiInsightsTitle: "AI-Powered Insights",
    aiInsightsDesc: "Automatic sentiment analysis, topic extraction, and weekly summaries. No manual work required.",
    earlyWarning: "Early Warning System",
    earlyWarningDesc: "Get alerts when ratings drop, detect negative spikes before they become problems.",
    analyticsDashboard: "Professional Analytics",
    analyticsDashboardDesc: "Visualize ratings, trends, and comparisons. Filter by date, product, sentiment, or channel.",
    multilingualSupport: "Multilingual Support",
    multilingualSupportDesc: "Available in Portuguese and English. Serve international customers in their preferred language.",
    // What makes different section
    whatMakesDifferent: "What Makes RoastPulse Different",
    madeForCoffee: "Made for Coffee",
    madeForCoffeeDesc: "Built specifically for coffee roasters, not a generic feedback tool. Includes coffee-specific taste tags.",
    zeroFriction: "Zero Friction",
    zeroFrictionDesc: "No app download, no account creation. Customers just scan and rate.",
    aiWorksForYou: "AI That Works for You",
    aiWorksForYouDesc: "Automatic analysis means you don't need to read every comment manually.",
    actionableData: "Actionable, Not Just Data",
    actionableDataDesc: "Get specific suggestions, not just numbers and charts.",
    growsWithYou: "Grows with You",
    growsWithYouDesc: "From small artisan roasters to large operations.",
    respectsPrivacy: "Respects Privacy",
    respectsPrivacyDesc: "Anonymous feedback option builds customer trust.",
  },
  privacy: {
    title: "Privacy Policy",
    lastUpdated: "Last updated",
    backToHome: "Back",
    allRightsReserved: "All rights reserved.",
    viewTerms: "View Terms of Use",
    email: "Email",
    // Introduction
    introTitle: "1. Introduction",
    introText: "RoastPulse is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our feedback platform for coffee roasters. This policy complies with the Brazilian General Data Protection Law (LGPD - Law No. 13,709/2018).",
    // Data Controller
    controllerTitle: "2. Data Controller",
    controllerText: "The data controller responsible for processing your personal data is:",
    // Data Collected
    dataCollectedTitle: "3. Data We Collect",
    roasterDataTitle: "For Roasters (Business Users)",
    roasterData1: "Authentication data (email and encrypted password)",
    roasterData2: "Profile data (username, display name, avatar, bio)",
    roasterData3: "Business data (roaster name, logo, website, slug)",
    roasterData4: "Payment data (Stripe customer ID for subscription processing)",
    consumerDataTitle: "For Consumers (Submitting Feedback)",
    consumerData1: "Feedback content (rating, comment, taste tags, purchase channel, repurchase intent)",
    consumerData2: "Email (optional, for follow-up - feedback is anonymous by default)",
    consumerData3: "AI-processed data (sentiment score, sentiment label, extracted topics)",
    // Data Use
    dataUseTitle: "4. How We Use Your Data",
    dataUse1: "To provide and maintain our feedback platform service",
    dataUse2: "To process and analyze feedback using artificial intelligence",
    dataUse3: "To generate insights, summaries, and recommendations for roasters",
    dataUse4: "To process payments and manage subscriptions",
    dataUse5: "To communicate with you about your account and service updates",
    // Legal Basis
    legalBasisTitle: "5. Legal Basis for Processing (LGPD Art. 7)",
    legalBasisIntro: "We process your personal data based on the following legal grounds:",
    legalBasis1Label: "Contract Performance",
    legalBasis1Text: "To provide our services as agreed when you created your account",
    legalBasis2Label: "Consent",
    legalBasis2Text: "For optional processing such as marketing communications (you may withdraw at any time)",
    legalBasis3Label: "Legitimate Interest",
    legalBasis3Text: "To improve our services and prevent fraud",
    // Data Sharing
    dataSharingTitle: "6. Data Sharing",
    dataSharingIntro: "We may share your data with the following third-party service providers:",
    dataSharing1: "Cloud database and authentication services",
    dataSharing2: "Payment processing for subscriptions",
    dataSharing3: "Sentiment analysis and natural language processing",
    aiProviders: "AI Providers",
    // AI Processing and User Responsibility
    aiProcessingTitle: "AI Processing and User Responsibility",
    aiProcessingText: "When feedback is submitted, it is automatically processed by AI systems (powered by OpenAI) to generate sentiment scores, extract topics, and create summaries. This processing helps provide insights about customer feedback patterns.",
    aiProcessingDisclaimer: "Important: AI-generated metrics, insights, and suggestions are algorithmic outputs based on pattern recognition and natural language processing. They are not guarantees of accuracy and may contain errors or misinterpretations. You are responsible for reviewing and verifying all AI-generated insights before making any business decisions. AI results should be used as a reference tool, not as the sole basis for action.",
    // Retention
    retentionTitle: "7. Data Retention",
    retentionText: "We retain your personal data only for as long as necessary to fulfill the purposes described in this policy. Account data is kept while your account remains active. Feedback data is retained to provide analytics and insights to roasters. You may request deletion of your data at any time.",
    // Rights
    rightsTitle: "8. Your Rights (LGPD Art. 18)",
    rightsIntro: "Under the LGPD, you have the following rights regarding your personal data:",
    rights1: "Confirmation of data processing existence",
    rights2: "Access to your personal data",
    rights3: "Correction of incomplete, inaccurate, or outdated data",
    rights4: "Anonymization, blocking, or deletion of unnecessary or excessive data",
    rights5: "Data portability to another service provider",
    rights6: "Deletion of personal data processed with consent",
    rights7: "Withdrawal of consent at any time",
    rightsContact: "To exercise any of these rights, please contact us using the contact information provided below.",
    // Cookies
    cookiesTitle: "9. Cookies and Tracking Technologies",
    cookiesText: "We use essential cookies for session management and authentication. We do not use third-party tracking cookies for advertising. You can manage cookie preferences through your browser settings.",
    // Security
    securityTitle: "10. Data Security (LGPD Art. 46)",
    securityText: "We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. This includes encryption, access controls, and regular security audits.",
    // Changes
    changesTitle: "11. Changes to This Policy",
    changesText: "We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new policy on our website and updating the \"Last updated\" date. We encourage you to review this policy periodically.",
    // Contact
    contactTitle: "12. Contact Us",
    contactText: "If you have questions about this Privacy Policy or wish to exercise your data protection rights, please contact us:",
  },
  billing: {
    // General
    used: "used",
    products: "Products",
    lots: "Lots",
    feedbackThisMonth: "Feedback this month",
    // Read-only mode (excess products)
    readOnly: "Read-only",
    overLimitBanner: "You have {count} products over your plan limit of {limit}.",
    upgradeToUnlock: "Upgrade to unlock",
    productReadOnlyBanner: "This product is over your plan limit. Editing is disabled and new feedback is hidden.",
    // Hidden feedback teaser
    hiddenFeedbackCount: "{count} new feedbacks hidden",
    hiddenFeedbackSubtitle: "Submitted since your subscription ended",
    unlockBenefit1: "View all feedback content",
    unlockBenefit2: "AI-powered insights and analysis",
    upgradeToSee: "Upgrade to see feedback",
    // Pricing
    choosePlan: "Choose Your Plan",
    choosePlanDescription: "Select the plan that best fits your roastery",
    monthly: "Monthly",
    yearly: "Yearly",
    month: "month",
    billedYearly: "billed yearly",
    year: "year",
    savePercent: "Save {percent}%",
    savingsPerYear: "You save {amount}/year",
    recommended: "Recommended",
    currentPlan: "Current Plan",
    selectPlan: "Select Plan",
    processing: "Processing...",
    upgradeNow: "Upgrade Now",
    upgrade: "Upgrade",
    downgrade: "Downgrade",
    cancelSubscription: "Cancel Subscription",
    cancelSubscriptionConfirmTitle: "Cancel Subscription?",
    cancelSubscriptionConfirmDescription: "Your {plan} subscription will remain active until {date}. After this date, you'll be switched to the Free plan and will no longer be charged.",
    cancelSubscriptionConfirm: "Yes, cancel subscription",
    cancelSubscriptionCancel: "Keep my subscription",
    canceling: "Canceling...",
    cancelSuccess: "Your subscription has been canceled. You'll retain access until the end of your billing period.",
    cancelError: "Failed to cancel subscription. Please try again.",
    downgradeSuccess: "Your plan will change to Starter at the end of your billing period.",
    downgradeError: "Failed to downgrade subscription. Please try again.",
    downgradeScheduled: "Downgrade scheduled",
    downgradeScheduledMessage: "Your plan will change to {tier} on {date}.",
    downgradeScheduledStatus: "Your plan will change to {tier} at the end of your billing period.",
    free: "Free",
    cancelAnytime: "Cancel anytime. No questions asked.",
    // Plan features
    unlimitedProducts: "Unlimited products",
    unlimitedLots: "Unlimited lots",
    unlimitedFeedback: "Unlimited feedback",
    upToProducts: "Up to {count} products",
    upToLots: "Up to {count} lots",
    upToFeedback: "Up to {count} feedback/month",
    aiAnalysis: "AI-powered analysis",
    noAiAnalysis: "No AI analysis",
    qrCodes: "QR code generation",
    prioritySupport: "Priority support",
    // Subscription details
    subscriptionDetails: "Subscription Details",
    billingCycle: "Billing Cycle",
    price: "Price",
    nextBillingDate: "Next Billing Date",
    cancelingAtPeriodEnd: "Your subscription will be canceled at the end of the billing period",
    subscriptionCanceled: "Canceled",
    canceledStatus: "Your subscription has been canceled",
    cancellationScheduled: "Cancellation Scheduled",
    cancellationScheduledStatus: "Your subscription is scheduled to cancel",
    subscriptionEndedStatus: "Your subscription has ended",
    subscriptionEndedDescription: "Your subscription has been canceled. You have access to the {plan} plan until {date}, after which you'll be moved to the Free plan.",
    accessUntil: "You'll have access to {plan} features until {date}",
    afterCancellation: "After this date, your account will switch to the Free plan",
    reactivateSubscription: "Reactivate Subscription",
    reactivateSubscriptionConfirmTitle: "Reactivate subscription?",
    reactivateSubscriptionConfirmDescription: "Your {plan} plan will be reactivated and will renew on {date}. You will continue to be charged at the end of each billing period.",
    reactivateSubscriptionConfirm: "Yes, reactivate",
    reactivateSubscriptionCancel: "Keep cancellation",
    reactivateSuccess: "Your subscription has been reactivated.",
    reactivateError: "Failed to reactivate subscription. Please try again.",
    currentUsage: "Current Usage",
    // Upgrade modal
    limitReached: "You've reached your limit",
    limitReachedDescription: "You've used {current} of {limit} {type}. Upgrade to continue.",
    productsLimit: "products",
    lotsLimit: "lots",
    feedbackLimit: "feedback",
    // Upgrade prompt
    upgradePromptTitle: "Unlock more features",
    upgradePromptDescription: "Upgrade to a paid plan and get more products, feedback, and save {percent}% with yearly billing.",
  },
  terms: {
    title: "Terms of Use",
    lastUpdated: "Last updated",
    backToHome: "Back",
    allRightsReserved: "All rights reserved.",
    viewPrivacy: "View Privacy Policy",
    email: "Email",
    // Acceptance
    acceptanceTitle: "1. Acceptance of Terms",
    acceptanceText: "By accessing or using the RoastPulse platform, you agree to be bound by these Terms of Use. If you do not agree with any part of these terms, you may not access or use our services. These terms are governed by Brazilian law.",
    // Service
    serviceTitle: "2. Service Description",
    serviceText: "RoastPulse is a feedback collection and analysis platform designed specifically for coffee roasters. Our service includes:",
    service1: "QR code generation for product feedback collection",
    service2: "AI-powered feedback analysis",
    service3: "Analytics dashboards and reporting",
    service4: "Alert system for rating anomalies",
    // Account
    accountTitle: "3. Account Registration and Responsibilities",
    accountText: "When creating an account, you agree to:",
    account1: "Provide accurate and complete information",
    account2: "Maintain the security of your account credentials",
    account3: "Notify us immediately of any unauthorized use",
    account4: "Be responsible for all activities under your account",
    // Acceptable Use
    acceptableUseTitle: "4. Acceptable Use",
    acceptableUseText: "You agree NOT to use our platform to:",
    acceptableUse1: "Violate any applicable laws or regulations",
    acceptableUse2: "Collect fake feedback or manipulate ratings",
    acceptableUse3: "Upload malicious content or spam",
    acceptableUse4: "Attempt unauthorized access to our systems",
    acceptableUse5: "Use data in ways that violate third-party privacy rights",
    // IP
    ipTitle: "5. Intellectual Property",
    ipText: "The RoastPulse platform, including its design, features, code, and content (excluding user-generated content), is owned by RoastPulse and protected by intellectual property laws. You may not copy, modify, distribute, or create derivative works without our express written permission.",
    // User Content
    userContentTitle: "6. User Content",
    userContentText: "You retain ownership of content you submit, including product information and business data. By using our service, you grant us a license to use, process, and display your content as necessary to operate the platform. Consumer feedback is collected on behalf of roasters and processed according to our Privacy Policy.",
    // Payment
    paymentTitle: "7. Payment Terms",
    paymentText: "For paid subscription plans:",
    payment1: "Payments are processed securely through Stripe",
    payment2: "Subscriptions renew automatically unless cancelled",
    payment3: "Refunds are handled on a case-by-case basis per our refund policy",
    // AI-Powered Features
    aiTitle: "8. AI-Powered Features and User Responsibility",
    aiIntro: "RoastPulse provides AI-powered features to help you analyze and understand customer feedback. It is essential that you understand the nature and limitations of these features.",
    aiFeatures: "Our AI features include:",
    aiFeature1: "Sentiment analysis of customer feedback",
    aiFeature2: "Topic extraction and categorization",
    aiFeature3: "Weekly summaries and actionable suggestions",
    aiFeature4: "Anomaly detection and alerts",
    aiProviderNote: "These features are powered by trusted third-party AI providers (such as OpenAI) that employ industry-standard security and privacy practices. While we select reliable providers, AI technology has inherent limitations.",
    aiUserResponsibility: "User Responsibility:",
    aiResponsibility1: "AI-generated insights, metrics, and suggestions are provided as assistive tools only and should be treated as a starting point for your analysis, not as definitive conclusions.",
    aiResponsibility2: "You must independently verify and validate all AI-generated insights before taking any action. AI analysis may contain inaccuracies, misinterpretations, or errors.",
    aiResponsibility3: "Use AI results as a baseline or reference point. Always apply your own business judgment and expertise when making decisions.",
    aiResponsibility4: "You bear full responsibility for any business decisions, actions, or strategies based on AI-generated insights. RoastPulse does not guarantee the accuracy, completeness, or suitability of AI outputs for your specific needs.",
    aiResponsibility5: "RoastPulse shall not be liable for any losses, damages, or consequences arising from actions taken based on AI-generated insights.",
    aiAcknowledgment: "By using our AI features, you acknowledge that you have read, understood, and agree to these terms regarding AI-powered functionality.",
    // Disclaimer
    disclaimerTitle: "9. Disclaimer of Warranties",
    disclaimerText: "The service is provided \"as is\" and \"as available\" without warranties of any kind, express or implied. We do not guarantee that the service will be uninterrupted, secure, or error-free.",
    // Liability
    liabilityTitle: "10. Limitation of Liability",
    liabilityText: "To the maximum extent permitted by Brazilian law, RoastPulse shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits, data, or business opportunities, arising from your use of or inability to use our service.",
    // Termination
    terminationTitle: "11. Termination",
    terminationText: "We may suspend or terminate your account if you violate these terms or for any other reason at our sole discretion. Upon termination, your right to use the service will cease immediately. You may terminate your account at any time through account settings.",
    // Governing Law
    governingLawTitle: "12. Governing Law",
    governingLawText: "These Terms of Use are governed by and construed in accordance with the laws of the Federative Republic of Brazil. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of Brazilian courts.",
    // Dispute
    disputeTitle: "13. Dispute Resolution",
    disputeText: "Any disputes or claims arising out of or relating to these terms shall first be addressed through good-faith negotiation. If a resolution cannot be reached, disputes will be resolved through arbitration or in the competent courts of Brazil, as per applicable law.",
    // Changes
    changesTitle: "14. Changes to Terms",
    changesText: "We reserve the right to modify these terms at any time. Changes will become effective upon posting the updated terms on our website. Your continued use of the service after any changes constitutes acceptance of the new terms.",
    // Contact
    contactTitle: "15. Contact Us",
    contactText: "If you have questions about these Terms of Use, please contact us:",
  },

  // Public roaster page
  publicPage: {
    poweredBy: "Made with RoastPulse",
    products: "Our Coffees",
    noProducts: "No products available yet.",
    noProductsSubtext: "Check back soon — new coffees are on the way!",
    customerFeedback: "Customer Reviews",
    noFeedback: "No reviews yet.",
    noFeedbackSubtext: "Be the first to share your experience!",
    lotLabel: "Lot",
    reviews: "reviews",
    review: "review",
    visitWebsite: "Visit Website",
    roasterNotFound: "Roaster not found",
    roasterNotFoundSubtext: "The page you're looking for doesn't exist or may have been moved.",
    allProducts: "All Products",
    showFeedback: "Show Reviews",
    hideFeedback: "Hide Reviews",
    averageRating: "avg",
    location: "Location",
    contactUs: "Contact",
    viewOnMap: "View on map",
    seeAllReviews: "See all {count} reviews",
    seeAllReviewsSingular: "See the review",
    ratingBreakdown: "Rating Breakdown",
    basedOnReviews: "Based on {count} reviews",
    basedOnReviewSingular: "Based on 1 review",
    stars: "stars",
    star: "star",
    clearFilter: "Clear",
  },
} as const;
